/**
 * Maintenance Mode Configuration and Utilities
 * Centralized maintenance mode management for the application
 */

// Get maintenance mode from environment variables
const MAINTENANCE_MODE = process.env.REACT_APP_MAINTENANCE_MODE === 'true';

// Admin bypass roles that can access the app during maintenance
const ADMIN_ROLES = ['admin', 'superadmin', 'developer'];

/**
 * Check if maintenance mode is enabled
 * @returns {boolean} True if maintenance mode is active
 */
export const isMaintenanceMode = () => {
  return MAINTENANCE_MODE;
};

/**
 * Check if current user has admin bypass privileges
 * @param {string|Array} userRole - User role(s) to check
 * @returns {boolean} True if user can bypass maintenance mode
 */
export const canBypassMaintenance = (userRole) => {
  if (!userRole) return false;
  
  const roles = Array.isArray(userRole) ? userRole : [userRole];
  return roles.some(role => ADMIN_ROLES.includes(role?.toLowerCase()));
};

/**
 * Check if maintenance page should be shown
 * @param {string|Array} userRole - Optional user role for admin bypass
 * @returns {boolean} True if maintenance page should be displayed
 */
export const shouldShowMaintenance = (userRole = null) => {
  return isMaintenanceMode() && !canBypassMaintenance(userRole);
};

/**
 * Get maintenance configuration
 * @returns {Object} Maintenance configuration object
 */
export const getMaintenanceConfig = () => {
  return {
    enabled: MAINTENANCE_MODE,
    adminRoles: ADMIN_ROLES,
    estimatedRecovery: '3 - 4 hours',
    contactEmail: 'support@chefrepublic.com',
    socialLinks: {
      twitter: 'https://twitter.com/chefrepublic',
      facebook: 'https://facebook.com/chefrepublic',
      instagram: 'https://instagram.com/chefrepublic'
    }
  };
};

const maintenanceUtils = {
  isMaintenanceMode,
  canBypassMaintenance,
  shouldShowMaintenance,
  getMaintenanceConfig
};

export default maintenanceUtils;
